/**
 * Whether the active workflow should hide auxiliary UI (field overview, split validation, etc.).
 * Completed sessions (stepsCompleted) are never treated as busy so stale queue / currentlyProcessing
 * flags do not block UI when switching between finished workflows.
 */
export function isActiveWorkflowProcessingBusyState(state) {
  const activeId = state.workflowSessions?.activeSessionId;
  if (!activeId) return false;

  const sessionState = state.workflowSessions?.sessions?.[activeId]?.state;
  if (sessionState?.stepsCompleted === true) return false;

  if (sessionState?.isProcessing === true) return true;

  if (state.workflowSessions?.currentlyProcessingSessionId === activeId) return true;

  const queue = state.workflowSessions?.processingQueue || [];
  if (Array.isArray(queue) && queue.includes(activeId)) return true;

  return false;
}
